export enum ListStyle {
    Grouped = 'grouped',
    Grid = 'grid',
}
